import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import App from './App.tsx';
import './index.css';
import toast from 'react-hot-toast';

// Only register service worker when not in StackBlitz
const isStackBlitz = window.location.hostname.includes('stackblitz') ||
                    window.navigator.userAgent.includes('StackBlitz');

// Create root and render app
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

// Only register service worker and request notifications when not in StackBlitz
if (!isStackBlitz) {
  let updateSW: (reloadPage?: boolean) => Promise<void>;
  let isUpdateToastVisible = false;

  const checkForUpdates = () => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((registration) => {
        registration.update();
      });
    }
  };

  updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      if (isUpdateToastVisible) return;
      isUpdateToastVisible = true;
      toast(
        (t) => (
          <div className="flex flex-col">
            <p className="font-semibold">A new version is available</p>
            <p className="text-sm text-gray-600 mt-1">Reload to get the latest updates.</p>
            <button
              className="mt-3 bg-indigo-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-indigo-700"
              onClick={() => {
                isUpdateToastVisible = false;
                updateSW(true);
                toast.dismiss(t.id);
              }}
            >
              Reload Now
            </button>
          </div>
        ),
        {
          duration: Infinity,
          icon: '🚀',
          style: {
            border: '1px solid #4f46e5',
            padding: '16px',
          },
        }
      );
    },
    onOfflineReady() {
      toast.success('App ready to work offline', {
        icon: '📱',
        duration: 3000,
      });
    }
  });

  // Check for updates every 30 minutes (for long-lived PWA sessions)
  setInterval(checkForUpdates, 30 * 60 * 1000);

  // Check for updates when the user returns to the app (tab becomes visible)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      checkForUpdates();
    }
  });

  // Request notification permission on mount
  if ('Notification' in window) {
    Notification.requestPermission().then((permission) => {
      if (permission === 'granted') {
        console.info('Notification permission granted');
      }
    });
  }
}
